// extracted by mini-css-extract-plugin
export default {"loader":"GrowingLoader_loader__kc5C-","loader3":"GrowingLoader_loader3__Y+MpK"};